import {ParameterStore} from './ParameterStore';

export const ParameterStoreKeys: {[k in keyof ParameterStore]?: string} = {
    approval: 'approval',
    prequal: 'prequal',
    health: 'health',
    quote: 'quote',
};

// These currently mirror eachother for quick lookup
// If a field comes from preapproval or prequal, lookup here to see
// if we should update the corresponding field in the other parameter class
export const parameterRefs = {
    approval: {
        firstName: ParameterStoreKeys.prequal,
        lastName: ParameterStoreKeys.prequal,
        middleName: ParameterStoreKeys.prequal,
        suffix: ParameterStoreKeys.prequal,
        bmonth: ParameterStoreKeys.prequal,
        bday: ParameterStoreKeys.prequal,
        byear: ParameterStoreKeys.prequal,
        age: ParameterStoreKeys.prequal,
        gender: ParameterStoreKeys.prequal,
        maritalStatus: ParameterStoreKeys.prequal,
        state: ParameterStoreKeys.prequal,
        height: ParameterStoreKeys.prequal,
        weight: ParameterStoreKeys.prequal,
        incomeHouseholdText: ParameterStoreKeys.prequal,
        incomeIndividual: ParameterStoreKeys.prequal,
        currentlyEmployed: ParameterStoreKeys.prequal,
        currentSelfEmployed: ParameterStoreKeys.prequal,
        nameOfEmployer: ParameterStoreKeys.prequal,
        timeEmployed: ParameterStoreKeys.prequal,
        employmentDays: ParameterStoreKeys.prequal,
        employerAddress: ParameterStoreKeys.prequal,
        occupation: ParameterStoreKeys.prequal,
        industryDuties: ParameterStoreKeys.prequal,
        prevSelfEmployed: ParameterStoreKeys.prequal,
        prevEmployName: ParameterStoreKeys.prequal,
        prevEmployStart: ParameterStoreKeys.prequal,
        prevEmployOccup: ParameterStoreKeys.prequal,
        prevEmployIndustry: ParameterStoreKeys.prequal,
        reasonUnemployed: ParameterStoreKeys.prequal,
        previousJobInfo: ParameterStoreKeys.prequal,
        previousIncome: ParameterStoreKeys.prequal,
        retiredInfo: ParameterStoreKeys.prequal,
        retiredIncome: ParameterStoreKeys.prequal,
        schoolInfo: ParameterStoreKeys.prequal,
        disabilityInfo: ParameterStoreKeys.prequal,
        otherInfo: ParameterStoreKeys.prequal,
        existingCoverage: ParameterStoreKeys.prequal,
        existingCarrier: ParameterStoreKeys.prequal,
        existingPolicyType: ParameterStoreKeys.prequal,
        existingCoverageAmount: ParameterStoreKeys.prequal,
        replacingExistingPolicy: ParameterStoreKeys.prequal,
        policyEverBeenDeclined: ParameterStoreKeys.prequal,
        policyNumber: ParameterStoreKeys.prequal,
        accidentalDeathBenefitAmount: ParameterStoreKeys.prequal,
        howLongInforce: ParameterStoreKeys.prequal,
        shoppedCoverage: ParameterStoreKeys.prequal,
        shoppedCarrier: ParameterStoreKeys.prequal,
        shoppedPolicyType: ParameterStoreKeys.prequal,
        shoppedCoverageAmount: ParameterStoreKeys.prequal,
        DrugorAlcoholDependenceWithdrawal: ParameterStoreKeys.prequal,
        DUI: ParameterStoreKeys.prequal,
        License: ParameterStoreKeys.prequal,
        suspendedLicense: ParameterStoreKeys.prequal,
        Movingviolations: ParameterStoreKeys.prequal,
        Criminaloffense: ParameterStoreKeys.prequal,
        criminalOffenseDate: ParameterStoreKeys.prequal,
        criminalOffenseChargeType: ParameterStoreKeys.prequal,
        criminalOffenseProbation: ParameterStoreKeys.prequal,
        Bankruptcy: ParameterStoreKeys.prequal,
        bankruptcyOpen: ParameterStoreKeys.prequal,
        HIV: ParameterStoreKeys.prequal,
        extremeSports: ParameterStoreKeys.prequal,
        livingAssistance: ParameterStoreKeys.prequal,
        notes: ParameterStoreKeys.prequal,
        kidsNumber: ParameterStoreKeys.prequal,
        usCitizenship: ParameterStoreKeys.prequal,
    },
    prequal: {
        firstName: ParameterStoreKeys.approval,
        lastName: ParameterStoreKeys.approval,
        middleName: ParameterStoreKeys.approval,
        suffix: ParameterStoreKeys.approval,
        bmonth: ParameterStoreKeys.approval,
        bday: ParameterStoreKeys.approval,
        byear: ParameterStoreKeys.approval,
        age: ParameterStoreKeys.approval,
        gender: ParameterStoreKeys.approval,
        maritalStatus: ParameterStoreKeys.approval,
        state: ParameterStoreKeys.approval,
        height: ParameterStoreKeys.approval,
        weight: ParameterStoreKeys.approval,
        incomeHouseholdText: ParameterStoreKeys.approval,
        incomeIndividual: ParameterStoreKeys.approval,
        currentlyEmployed: ParameterStoreKeys.approval,
        currentSelfEmployed: ParameterStoreKeys.approval,
        nameOfEmployer: ParameterStoreKeys.approval,
        timeEmployed: ParameterStoreKeys.approval,
        employmentDays: ParameterStoreKeys.approval,
        employerAddress: ParameterStoreKeys.approval,
        occupation: ParameterStoreKeys.approval,
        industryDuties: ParameterStoreKeys.approval,
        prevSelfEmployed: ParameterStoreKeys.approval,
        prevEmployName: ParameterStoreKeys.approval,
        prevEmployStart: ParameterStoreKeys.approval,
        prevEmployOccup: ParameterStoreKeys.approval,
        prevEmployIndustry: ParameterStoreKeys.approval,
        reasonUnemployed: ParameterStoreKeys.approval,
        previousJobInfo: ParameterStoreKeys.approval,
        previousIncome: ParameterStoreKeys.approval,
        retiredInfo: ParameterStoreKeys.approval,
        retiredIncome: ParameterStoreKeys.approval,
        schoolInfo: ParameterStoreKeys.approval,
        disabilityInfo: ParameterStoreKeys.approval,
        otherInfo: ParameterStoreKeys.approval,
        existingCoverage: ParameterStoreKeys.approval,
        existingCarrier: ParameterStoreKeys.approval,
        existingPolicyType: ParameterStoreKeys.approval,
        existingCoverageAmount: ParameterStoreKeys.approval,
        replacingExistingPolicy: ParameterStoreKeys.approval,
        policyEverBeenDeclined: ParameterStoreKeys.approval,
        policyNumber: ParameterStoreKeys.approval,
        accidentalDeathBenefitAmount: ParameterStoreKeys.approval,
        howLongInforce: ParameterStoreKeys.approval,
        shoppedCoverage: ParameterStoreKeys.approval,
        shoppedCarrier: ParameterStoreKeys.approval,
        shoppedPolicyType: ParameterStoreKeys.approval,
        shoppedCoverageAmount: ParameterStoreKeys.approval,
        DrugorAlcoholDependenceWithdrawal: ParameterStoreKeys.approval,
        DUI: ParameterStoreKeys.approval,
        License: ParameterStoreKeys.approval,
        suspendedLicense: ParameterStoreKeys.approval,
        Movingviolations: ParameterStoreKeys.approval,
        Criminaloffense: ParameterStoreKeys.approval,
        criminalOffenseDate: ParameterStoreKeys.approval,
        criminalOffenseChargeType: ParameterStoreKeys.approval,
        criminalOffenseProbation: ParameterStoreKeys.approval,
        Bankruptcy: ParameterStoreKeys.approval,
        bankruptcyOpen: ParameterStoreKeys.approval,
        HIV: ParameterStoreKeys.approval,
        extremeSports: ParameterStoreKeys.approval,
        livingAssistance: ParameterStoreKeys.approval,
        notes: ParameterStoreKeys.approval,
        kidsNumber: ParameterStoreKeys.approval,
        usCitizenship: ParameterStoreKeys.approval,
    },
};
